import useExtensionUpdateControllerState from './useExtensionUpdateControllerState'

export default useExtensionUpdateControllerState
